var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Home")]),_vm._v(" "),_c('p',[_vm._v("\n    This is homepage for kubernetes to fetch for readiness probe\n  ")])])
}]

export { render, staticRenderFns }